export * from './lib/shared-slider-select.module';
